var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('eCharts',{ref:"line",attrs:{"options":_vm.options,"autoresize":true}})}
var staticRenderFns = []

export { render, staticRenderFns }